export default function () {
  const widgetName = 'seoBlockCount';
  const widgetOpts = seoBlockCountOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      // arguments: data, owl, hasData
      function communityShifted() {
        if ($('#body.homepage').hasClass('saffireLargeSize')) {
          $('.seo-block-outer .our-community').insertAfter(
            '.seo-block-outer #seoBlockCount .card-widget-item:nth-child(2)',
          );
        } else if ($('#body.homepage').hasClass('saffireMobileSize')) {
          $('.seo-block-outer .our-community').insertAfter('.seo-block-outer #seoBlockCount');
        }
      }
      $(document).ready(() => {
        communityShifted();
      });
      $(window).resize(() => {
        communityShifted();
      });
    },
    itemsPerPanel: 4,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
